import api from 'Application/api/api';

const updateProjectWorkingDays = (projectId, workingDays, cancelToken = null) =>
    api.post(
        `project-manager/projects/${projectId}/working-days`,
        {
            workingDays,
        },
        {
            cancelToken,
        },
    );

export default updateProjectWorkingDays;
